import { Snackbar, LinearProgress, Box } from '@mui/material';
import Alert from '@mui/material/Alert';
import { useState, useEffect } from 'react';

function SnackbarComponent({
  open,
  message,
  severity = 'info',
  onClose,
  anchorOrigin = { vertical: 'top', horizontal: 'right' },
  autoHideDuration = 6000,
  marginTop = 7,
}) {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    let intervalId;

    if (open) {
      setProgress(100);

      const updateProgress = () => {
        setProgress((prevProgress) => {
          if (prevProgress <= 0) {
            onClose();
            return 0;
          }
          return prevProgress - (100 / (autoHideDuration / 100));
        });
      };

      intervalId = setInterval(updateProgress, 100);
    } else {
      setProgress(100);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [open, autoHideDuration, onClose]);

  // Define color mapping based on severity
  const severityColor = {
    error: '#f44336',  // Red for error
    warning: '#ff9800',  // Orange for warning
    info: '#2196f3',     // Blue for info
    success: '#4caf50',  // Green for success
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      sx={{ mt: marginTop }}
    >
      <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }}>
        <Box sx={{ flexGrow: 1 }}>
          {message}
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              marginTop: 1,
              height: 4,
              backgroundColor: `${severityColor[severity]}33`, // Set background color with transparency (33 for ~20%)
              '& .MuiLinearProgress-bar': {
                backgroundColor: severityColor[severity], // Set the progress bar color based on severity
              },
            }}
          />
        </Box>
      </Alert>
    </Snackbar>
  );
}

export default SnackbarComponent;
